import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/productCenter',
    name: 'productCenter',
    component: () => import('@/views/productCenter')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('@/views/solution')
  },
  {
    path: '/researchConsulting',
    name: 'researchConsulting',
    component: () => import('@/views/researchConsulting')
  },
  {
    path: '/memberService',
    name: 'memberService',
    component: () => import('@/views/memberService')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/aboutUs')
  }
]

const router = new VueRouter({
  routes
})

export default router
